<template>
  <a-card :bordered="false">
    <a-form-model
      :model="ruleForm"
      ref="ruleForm"
      :rules="tabRule"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <div class="title">商城开关</div>
      <div class="top-box">
        <span>是否开启企业福利模式</span>
        <a-tooltip>
          <template slot="title">
            如果关闭后用户进入商城不再认证员工身份
          </template>
          <a-icon class="icon" type="question-circle" theme="filled"/>
        </a-tooltip>
        <a-switch checked-children="开" un-checked-children="关" v-model="isChecked"/>
      </div>
      <div class="title">
        <span>员工认证方式</span>
        <a-form-model-item label="员工认证方式" prop="authMethod">
          <a-radio-group v-model="ruleForm.authMethod" style="margin-left: 10px;">
            <a-radio :value="1">邮箱认证 (默认协议 SMTP)</a-radio>
            <a-radio :value="2">员工匹配认证</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </div>
      <template v-if="ruleForm.authMethod == 1">
        <a-form-model-item label="服务器地址" prop="emailHost">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.emailHost"
            :maxLength="50"
          />
        </a-form-model-item>
        <a-form-model-item label="服务器端口" prop="emailPort">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.emailPort"
            :maxLength="6"
          />
        </a-form-model-item>
        <a-form-model-item label="邮箱账号" prop="emailAccount">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.emailAccount"
            :maxLength="50"
          />
        </a-form-model-item>
        <a-form-model-item label="邮箱密码" prop="emailPassword">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.emailPassword"
            :maxLength="50"
          />
        </a-form-model-item>
        <a-form-model-item label="发件人名称" prop="emailPersonal">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.emailPersonal"
            :maxLength="50"
          />
        </a-form-model-item>
        <div class="title">邮件模板( 示例 )</div>
        <div class="box">
          <a-row>
            <a-col :span="5">发件人:</a-col>
            <a-col :span="18">{{ ruleForm.emailPersonal }} <{{ ruleForm.emailAccount }}></a-col>
          </a-row>
          <a-row>
            <a-col :span="5">您的验证码为:</a-col>
            <a-col :span="18">******</a-col>
          </a-row>
          <a-row>如非本人操作，请忽略此邮件，由此给您带来的不便请谅解！</a-row>
        </div>
      </template>
      <div class="title">员工过期模式</div>
      <a-form-model-item label="是否开启过期模式" prop="employeeExpireModuleStatus">
        <a-radio-group v-model="ruleForm.employeeExpireModuleStatus">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="2">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="ruleForm.employeeExpireModuleStatus === 1" label="周期" prop="employeeExpireDay">
        <a-input
          placeholder="请输入"
          v-model.number="ruleForm.employeeExpireDay"
          :maxLength="2"
          style="width: 70px;margin-right: 10px"
        />
        <span>天后过期，需重新激活</span>
      </a-form-model-item>
    </a-form-model>
    <a-button
      style="margin-left: 240px"
      htmlType="submit"
      type="primary"
      @click="submitEvent"
      :loading="submitLoading"
    >保存
    </a-button>
  </a-card>
</template>

<script>
import WelfareMallMixins from '@/views/service/serviceProvider/welfareMall/mixins/WelfareMallMixins'

export default {
  name: 'WelfareMallSettings',
  mixins: [WelfareMallMixins],
  data() {
    return {
      ruleForm: {
        authMethod: 1
      },
      tabRule: {
        authMethod: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        emailHost: [
          { required: true, message: '请输入服务器地址', trigger: ['blur', 'change'] }
        ],
        emailPort: [
          { required: true, message: '请输入服务器端口', trigger: ['blur', 'change'] },
          { pattern: /^\d+$/, message: '只能输入数字', trigger: ['blur', 'change'] }
        ],
        emailAccount: [
          { required: true, message: '请输入邮箱账号', trigger: ['blur', 'change'] },
          {
            pattern: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/,
            message: '邮箱格式不正确',
            trigger: ['blur', 'change']
          }
        ],
        emailPassword: [
          { required: true, message: '请输入邮箱密码', trigger: ['blur', 'change'] }
        ],
        emailPersonal: [
          { required: true, message: '请输入发件人名称', trigger: ['blur', 'change'] }
        ],
        employeeExpireDay: [
          { required: true, message: '请输入周期', trigger: ['blur', 'change'] },
          { type: 'number', min: 1, max: 90, message: '只能输入1-90之间的正整数', trigger: ['blur', 'change'] }
        ]
      },
      labelCol: { span: 3 },
      wrapperCol: { span: 10 },
      type: 1,
      submitLoading: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      isChecked: false
    }
  },
  created() {
    this.getConfigDetail()
  },
  methods: {
    getConfigDetail() {
      this.getHttpServices().getServerApiService().post('welfare/configDetail', {
        merchantId: this.merchantId,
        platformId: this.platformId
      }).then(res => {
        if (res) {
          res.authMethod = res.authMethod || 1
          this.ruleForm = res
          this.isChecked = this.ruleForm.status === 1
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        let params = {
          ...this.ruleForm,
          merchantId: this.merchantId,
          platformId: this.platformId,
          status: this.isChecked ? 1 : 2
        }
        this.getHttpServices().getServerApiService().post('welfare/saveConfig', params).then(res => {
          this.$message.success('保存成功')
          this.getDetailInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style lang="less">
@import url('../../../../views/CustomPage.less');
</style>
<style lang="less" scoped>
.title {
  padding-left: 10px;
  border-left: 1px solid cornflowerblue;
  margin: 10px 0;
}

.top-box {
  padding-left: 60px;
  display: flex;
  align-items: center;

  .icon {
    padding-top: 4px;
    margin: 0 10px;
    color: #77828C;
  }
}

.box {
  width: 44%;
  border: 1px solid #7f7f7f;
  margin-left: 40px;
  padding-top: 10px;

  ::v-deep .ant-col {
    &:first-child {
      text-align: right;
      margin-right: 6px;
    }
  }

  ::v-deep .ant-row {
    margin-bottom: 10px;

    &:last-child {
      padding-left: 18px;
    }
  }
}
</style>
